// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__IQosD","card-border":"style_card-border__2jC2O"};